import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "min-h-10 flex flex-wrap gap-2 mt-2 justify-center md:justify-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-12 p-1" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow flex" }
const _hoisted_10 = { class: "my-auto ml-2" }
const _hoisted_11 = { class: "cursor-pointer text-brand-promo-bg whitespace-nowrap flex" }
const _hoisted_12 = { class: "my-auto" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "flex w-full" }
const _hoisted_15 = { class: "flex-grow mb-6 text-2xl text-left font-light text-brand-headlines uppercase tracking-widest" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "w-12" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "flex-grow text-left pl-4 flex content-center" }
const _hoisted_22 = { class: "my-auto" }
const _hoisted_23 = { class: "flex-grow-0 flex content-center" }
const _hoisted_24 = { class: "my-auto w-full text-right pl-4 pr-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "pr-2" }, "+", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "pr-2" }, "-", -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full inline-block align-bottom bg-white p-4 text-left transform transition-all sm:align-middle\"><div class=\"text-center w-10 h-10 mx-auto\"><svg class=\"inline-block animate-spin m-auto h-10 w-10 text-brand-headlines\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg></div></div>", 1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_item_color = _resolveComponent("icon-item-color")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.itemObj)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemObj.getColors(), (color, colorIdx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'color' + colorIdx,
              class: "list-none flex-shrink"
            }, [
              _createVNode(_component_router_link, {
                to: {
            name: 'Item',
            params: {
              set: color.slug,
            },
          }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_item_color, {
                    colors: color.colors,
                    class: _normalizeClass(["h-10 w-10 p-1 border rounded-full border-white hover:border-gray-200", {
              'border-brand-promo-bg': color.match,
            }])
                  }, null, 8, ["colors", "class"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleVariations, (variation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: variation.idx
          }, [
            _hoisted_3,
            (_ctx.editParameter != variation.idx)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "relative flex content-center",
                  onClick: ($event: any) => (_ctx.editParameter = variation.idx)
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (variation.idx == 'metals' || variation.idx == 'finishes')
                      ? (_openBlock(), _createBlock(_component_icon_item_color, {
                          key: 0,
                          colors: _ctx.itemObj.parseColorList(),
                          class: "w-10"
                        }, null, 8, ["colors"]))
                      : (variation.idx == 'sizes')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: 
              _ctx.pluginHost +
              '/img/item/icons/stone/size/round_' +
              _ctx.getPossibleIconStoneSize(variation.desc) +
              '.svg'
            ,
                            class: "w-10",
                            alt: ""
                          }, null, 8, _hoisted_6))
                        : (variation.idx == 'quality')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              src: 
              _ctx.pluginHost +
              '/img/item/icons/stone/quality/' +
              _ctx.getPossibleIconStoneQuality(variation.desc) +
              '@2x.png'
            ,
                              class: "w-10 p-2",
                              alt: ""
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 3,
                              src: 
              'https://conf.conftec.com/v2/images/item/ffffff/200/200/' +
              _ctx.itemObj.getItemnumber() +
              '.jpg'
            ,
                              class: "w-10",
                              alt: ""
                            }, null, 8, _hoisted_8))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(variation.desc), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(_ctx.pageStr + variation.cta)), 1)
                  ])
                ], 8, _hoisted_4))
              : (_ctx.editParameter == variation.idx)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(_ctx.pageStr + variation.title)), 1),
                      (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        class: "h-6 w-6 flex-shrink cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editParameter = ''))
                      }, _hoisted_17))
                    ]),
                    _createElementVNode("ul", {
                      class: _normalizeClass(["mb-5 flex flex-wrap", {
            'space-y-3':
              variation.idx != 'models' && variation.idx != 'settings',
          }])
                    }, [
                      (variation.idx != 'models' && variation.idx != 'settings')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(variation.list, (item, itemIdx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: 'quality' + itemIdx,
                              class: "list-none hover:bg-gray-100 rounded-md flex w-full"
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                (
                    variation.idx == 'metals' || variation.idx == 'finishes'
                  )
                                  ? (_openBlock(), _createBlock(_component_icon_item_color, {
                                      key: 0,
                                      colors: _ctx.itemObj.parseColorList(),
                                      class: _normalizeClass(["w-12 h-12 p-1", {
                    'border rounded-full border-brand-promo-bg': item.match,
                  }])
                                    }, null, 8, ["colors", "class"]))
                                  : (variation.idx == 'sizes')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: 
                    _ctx.pluginHost +
                    '/img/item/icons/stone/size/round_' +
                    _ctx.getPossibleIconStoneSize(item.desc) +
                    '.svg'
                  ,
                                        class: _normalizeClass(["w-12 h-10 p-2", {
                    'border rounded-full border-brand-promo-bg': item.match,
                  }]),
                                        alt: ""
                                      }, null, 10, _hoisted_19))
                                    : (variation.idx == 'quality')
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 2,
                                          src: 
                    _ctx.pluginHost +
                    '/img/item/icons/stone/quality/' +
                    _ctx.getPossibleIconStoneQuality(item.desc) +
                    '@2x.png'
                  ,
                                          alt: "",
                                          class: _normalizeClass(["w-12 h-10 p-2", {
                    'border rounded-full border-brand-promo-bg': item.match,
                  }])
                                        }, null, 10, _hoisted_20))
                                      : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_router_link, {
                                class: "w-full flex content-center",
                                to: {
                  name: 'Item',
                  params: {
                    set: item.slug,
                  },
                }
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.desc), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("span", _hoisted_24, [
                                      (item.price != 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (item.price - _ctx.itemObj.getPrice() > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _hoisted_25,
                                                  _createTextVNode(_toDisplayString(_ctx.$n(
                            Math.abs(item.price - _ctx.itemObj.getPrice()),
                            "currency"
                          )), 1)
                                                ], 64))
                                              : (item.price - _ctx.itemObj.getPrice() < 0)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _hoisted_26,
                                                    _createTextVNode(_toDisplayString(_ctx.$n(
                            Math.abs(item.price - _ctx.itemObj.getPrice()),
                            "currency"
                          )), 1)
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(variation.list, (item, itemIdx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: 'quality' + itemIdx,
                              class: "list-none hover:border hover: border-brand-promo-bg rounded-md flex w-1/2"
                            }, [
                              _createVNode(_component_router_link, {
                                class: "w-full flex content-center",
                                to: {
                name: 'Item',
                params: {
                  set: item.slug,
                },
              }
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: 
                  'https://conf.conftec.com/v2/images/item/ffffff/200/200/' +
                  item.slug.toUpperCase() +
                  '.jpg'
                ,
                                    class: _normalizeClass(["w-full", {
                  'border rounded-full border-brand-promo-bg': item.match,
                }]),
                                    alt: ""
                                  }, null, 10, _hoisted_27)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.loadingSessions > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}